<!-- @format -->

<template>
  <b-card class="mb-3">
    <div class="m-2">
      <b-row>
        <b-col md="2" class="mb-2">
          <div class="d-flex align-items-center">
            <span style="width: 45px;">Page:</span>
            <b-form-select v-model="pageSize" :options="options" size="sm" />
          </div>
        </b-col>
        <b-col md="3" class="mb-2">
          <div class="d-flex align-items-center">
            <span style="width: 85px; flex-shrink: 0;">Start Date:</span>
            <flat-pickr
              id="startDatePicker"
              v-model="start_time"
              class="form-control form-control-sm"
              placeholder="mm/dd/yyyy"
              :config="datePickerConfig"
              @on-change="onStartDateChange"
            />
          </div>
        </b-col>
        <b-col md="3" class="mb-2">
          <div class="d-flex align-items-center">
            <span style="width: 80px; flex-shrink: 0;">End Date:</span>
            <flat-pickr
              id="endDatePicker"
              v-model="end_time"
              class="form-control form-control-sm"
              placeholder="mm/dd/yyyy"
              :config="datePickerConfig"
              @on-change="onEndDateChange"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" class="mb-2">
          <b-form-input v-model="id" size="sm" placeholder="Member id" />
        </b-col>
        <b-col md="4" class="mb-2">
          <b-form-input v-model="real_name" size="sm" placeholder="Member name" />
        </b-col>
      </b-row>
      <b-tabs v-model="tabIndex" content-class="mt-3" @input="chan">
        <b-tab title="Personal TP">
          <b-table :fields="itemsPerson" :items="itemsPersonItem" empty-text="No data" show-empty>
            <template #cell(active_tp)="data">
              <div class="font-weight-bold">{{ data.value }}</div>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Baseshop TP">
          <b-table :fields="itemsPerson2" :items="itemsPersonItem" empty-text="No data" show-empty>
            <template #cell(active_tp)="data">
              <div class="font-weight-bold" @click="getActiveTeamTp(data)">{{ data.value }}</div>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Superbase TP">
          <b-table :fields="itemsPerson" :items="itemsPersonItem" empty-text="No data" show-empty>
            <template #cell(active_tp)="data">
              <div class="font-weight-bold" @click="getActiveTeamTp(data)">{{ data.value }}</div>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Infinity TP">
          <b-table :fields="itemsPerson" :items="itemsPersonItem" empty-text="No data" show-empty>
            <template #cell(active_tp)="data">
              <div class="font-weight-bold" @click="getActiveTeamTp(data)">{{ data.value }}</div>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
      <b-pagination
        v-model="currentPage"
        :total-rows="total"
        :per-page="paginationPerPage"
        aria-controls="my-table"
        class="my-0"
        align="center"
      />
    </div>
  </b-card>
</template>

<script>
import { BTabs, BTab, BCard, BTable, BFormSelect, BPagination } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { computed, getCurrentInstance, ref, watch } from '@vue/composition-api'
import axiosIns from '@/libs/axios'

const formatDateForApi = value => {
  if (!value) return ''
  const trimmed = String(value).trim()
  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (isoMatch) {
    const [, year, month, day] = isoMatch
    return `${month}/${day}/${year}`
  }
  return trimmed
}

export default {
  components: {
    BTabs,
    BTab,
    BTable,
    BCard,
    BFormSelect,
    BPagination,
    flatPickr,
  },
  setup() {
    const { proxy } = getCurrentInstance()

    const itemsPerson = [
      {
        key: 'key',
        label: 'ID',
      },
      {
        key: 'real_name',
        label: 'Agent',
      },
      {
        key: 'active_tp',
        label: 'Inforce Tp',
        formatter: value => `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
      },
      {
        key: 'pid',
        label: 'Sponsor',
      },
      {
        key: 'parent_name',
        label: 'Sponsor Agent',
      },
    ]
    const itemsPerson2 = [
      {
        key: 'user_id',
        label: 'ID',
      },
      {
        key: 'real_name',
        label: 'Leader',
      },
      {
        key: 'active_tp',
        label: 'Inforce Tp',
        formatter: value => `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
      },
      {
        key: 'pid',
        label: 'Sponsor',
      },
      {
        key: 'parent_name',
        label: 'Sponsor Agent',
      },
    ]

    const itemsPersonItem = ref([])

    const datePickerConfig = {
      altInput: true,
      altFormat: 'm/d/Y',
      dateFormat: 'Y-m-d',
    }

    const pageSize = ref(null)
    const currentPage = ref(1)
    const total = ref(0)
    const paginationPerPage = computed(() => pageSize.value || 200)
    const options = [
      { value: null, text: '' },
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 50, text: '50' },
      { value: 100, text: '100' },
    ]

    const start_time = ref('')
    const end_time = ref('')
    const id = ref('')
    const real_name = ref('')
    const cate_id = ref('')
    const tabIndex = ref(0)

    const buildParams = () => ({
      cate_id: cate_id.value,
      start_date: formatDateForApi(start_time.value),
      end_date: formatDateForApi(end_time.value),
      page_size: pageSize.value || 200,
      page: currentPage.value,
      id: id.value,
      real_name: real_name.value,
    })

    const fetchData = () => {
      axiosIns
        .get('OrderPer/tp', { params: buildParams() })
        .then(res => {
          const list = res.data?.list?.map(item => (item[0] ? item[0] : item)) || []
          itemsPersonItem.value = list
          total.value = res.data?.total
        })
    }

    const onStartDateChange = (selectedDates, dateStr) => {
      start_time.value = dateStr || ''
      currentPage.value = 1
      fetchData()
    }

    const onEndDateChange = (selectedDates, dateStr) => {
      end_time.value = dateStr || ''
      currentPage.value = 1
      fetchData()
    }

    watch([pageSize, id, real_name, currentPage], () => {
      fetchData()
    })

    const getActiveTeamTp = () => {}

    const chan = val => {
      cate_id.value = val + 1
      itemsPersonItem.value = []
      fetchData()
    }

    if (proxy.$route.query.tabIndex) {
      tabIndex.value = parseInt(proxy.$route.query.tabIndex, 10)
    }
    chan(tabIndex.value)

    return {
      cate_id,
      currentPage,
      total,
      fetchData,
      options,
      datePickerConfig,
      id,
      real_name,
      start_time,
      end_time,
      onStartDateChange,
      onEndDateChange,
      chan,
      pageSize,
      paginationPerPage,
      itemsPerson,
      itemsPersonItem,
      itemsPerson2,
      getActiveTeamTp,
      tabIndex,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to?.query?.name) {
        vm.real_name = to.query.name
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.tab-pane {
  overflow: auto;
}
</style>
